
/* ORDER */
export const GET_ORDER_LISTING = "GET_ORDER_LISTING";
export const GET_ORDER_LISTING_SUCCESS = "GET_ORDER_LISTING_SUCCESS";
export const GET_ORDER_LISTING_FAIL = "GET_ORDER_LISTING_FAIL";

export const GET_ORDER_DETAILS = "GET_ORDER_DETAILS";
export const GET_ORDER_DETAILS_SUCCESS = "GET_ORDER_DETAILS_SUCCESS";
export const GET_ORDER_DETAILS_FAIL = "GET_ORDER_DETAILS_FAIL";

export const UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS";
export const UPDATE_ORDER_STATUS_SUCCESS = "UPDATE_ORDER_STATUS_SUCCESS";
export const UPDATE_ORDER_STATUS_FAIL = "UPDATE_ORDER_STATUS_FAIL";

export const EXPORT_ORDER = "EXPORT_ORDER";
export const EXPORT_ORDER_SUCCESS = "EXPORT_ORDER_SUCCESS";
export const EXPORT_ORDER_FAIL = "EXPORT_ORDER_FAIL";

export const EXPORT_ORDER_DETAILS = "EXPORT_ORDER_DETAILS";
export const EXPORT_ORDER_DETAILS_SUCCESS = "EXPORT_ORDER_DETAILS_SUCCESS";
export const EXPORT_ORDER_DETAILS_FAIL = "EXPORT_ORDER_DETAILS_FAIL";

export const RESET_ORDER_STATE = 'RESET_ORDER_STATE';
export const RESET_ORDER_ACTION_STATE = 'RESET_ORDER_ACTION_STATE';